import { Grid } from "@mui/material";
import TotalCard from "./Charts/TotalCard";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ApartmentIcon from "@mui/icons-material/Apartment";
import EventIcon from "@mui/icons-material/Event";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import BusinessIcon from "@mui/icons-material/Business";

interface Props {
  counts: {
    total_employees: number;
    total_schedules: number;
    total_facilities: number;
    total_new_employees: number;
    total_timesheet: number;
    total_subfacilities: number;
  };
}

export default function Counts(props: Props) {
  return (
    <Grid container spacing={2}>
      <>
        <Grid item xs={6} md={4} lg={2}>
          <TotalCard
            title="Total Employee"
            count={props.counts?.total_employees ?? 0}
            Icon={PeopleAltIcon}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={2}>
          <TotalCard
            title="Total New Employees"
            count={props.counts?.total_new_employees ?? 0}
            Icon={PersonAddAltIcon}
          />
        </Grid>
      </>
      <>
        <Grid item xs={6} md={4} lg={2}>
          <TotalCard
            title="Total Events"
            count={props.counts?.total_schedules ?? 0}
            Icon={EventIcon}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={2}>
          <TotalCard
            title="Total Attendance"
            count={props.counts?.total_timesheet ?? 0}
            Icon={AssignmentIcon}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={2}>
          <TotalCard
            title="Total Facility"
            count={props.counts?.total_facilities ?? 0}
            Icon={ApartmentIcon}
          />
        </Grid>
        <Grid item xs={6} md={4} lg={2}>
          <TotalCard
            title="Total Sub Facility"
            count={props.counts?.total_subfacilities ?? 0}
            Icon={BusinessIcon}
          />
        </Grid>
      </>
    </Grid>
  );
}
